import React from 'react';
import { motion } from 'framer-motion';
import PillBadge from './PillBadge';

const AboutSection = ({ userData }) => {
  return (
    <section id="about" className="pt-20 bg-black overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Centered Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center space-y-8 lg:space-y-12"
        >
          {/* About Tag */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <PillBadge text={"About"} icon={''} className="mb-8" />
          </motion.div>

          {/* Main Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight"
          >
            <span className="text-[#999999]">I am a Senior Video Editor & </span>
            <span className="text-white">Motion Graphics Designer</span>
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-[#999999] text-lg lg:text-xl leading-relaxed max-w-4xl mx-auto"
          >
            With 16+ years of experience, I craft compelling visuals for brands, agencies, and live events. From commercials and corporate films to music tours and cultural festivals, I blend creativity and precision to turn ideas into content that engages and inspires.
          </motion.p>

          {/* Quote */}
          <motion.blockquote
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-white text-xl lg:text-2xl italic font-medium max-w-3xl mx-auto py-4"
          >
            "Editing is my craft, storytelling is my purpose."
          </motion.blockquote>

          {/* Stats Grid */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 max-w-5xl mx-auto"
          >
            {[ 
              { label: "Years of Experience", value: "16+" },
              { label: "Clients Served", value: "50+" },
              { label: "Projects Completed", value: "500+" },
              { label: "Hours of Editing & Design", value: "18,000+" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                className="bg-[#0E0E0E] border border-[#333333] rounded-2xl p-6 hover:bg-[#0f0f0f] transition-colors duration-300"
              >
                <div className="text-3xl lg:text-4xl font-bold text-white mb-2">{stat.value}</div>
                <div className="text-[#999999] text-sm lg:text-base">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
        
        {/* Client Logos Carousel */}
      </div>
    </section>
  );
};

export default AboutSection;
